export const QUERY_KEYS = {
  ADMIN_CHECK_DEPOSIT: 'adminCheckDeposit',
  ADMIN_CHECK_DEPOSIT_INDEX: 'adminCheckDepositIndex',
  ADMIN_CHECK_DEPOSIT_REJECT: 'adminCheckDepositReject',
  ADMIN_CHECK_DEPOSIT_APPROVE: 'adminCheckDepositApprove',
};
